module.exports = __webpack_public_path__ + "assets/media/drift-icon-large.3911ff91.svg";